import { AdminLayout, useTranslation } from "@opendash/core";
import { AdminToolbar } from "@opendash/ui";
import { Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { ProjectOverviewFilter } from "../../features/tickets/projects/components/ProjectOverviewFilter";
import { ProjectsOverview } from "../../features/tickets/projects/components/ProjectsOverview";
import { ProjectsManagerContextProvider } from "../../features/tickets/projects/context/ProjectsManagerContext";
import { useProjectFilter } from "../../features/tickets/projects/hooks/useProjectFilter";
import { ProjectsManager } from "../../features/tickets/projects/states/ProjectsManager";

type Props = {};

export const ProjectsOverviewPage = observer((props: Props) => {
  const t = useTranslation();
  const { filters, setFilter } = useProjectFilter();
  const projectsManager = useMemo(() => new ProjectsManager(), []);

  function handleSearch(value: string) {
    if (!value) setFilter("search", undefined);
    else setFilter("search", value);
  }

  return (
    <AdminLayout>
      <AdminToolbar
        title={t("maintenance:menu.tickets.projects_label")}
        actions={
          <>
            <Select
              options={projectsManager.viewOptions.map((view) => ({
                label: t(view.translationKey),
                value: view.value,
              }))}
              onChange={(view) => projectsManager.setView(view)}
              defaultValue={projectsManager.currentView}
              style={{ minWidth: 120 }}
            />
            <ProjectOverviewFilter />
          </>
        }
        search={filters.search}
        onSearch={handleSearch}
      />
      <ProjectsManagerContextProvider value={projectsManager}>
        <ProjectsOverview />
      </ProjectsManagerContextProvider>
    </AdminLayout>
  );
});
